// GA4 + Meta Pixel tracking. Scripts are injected ONLY when IDs are provided via env:
//   REACT_APP_GA4_ID=e.g. G-XXXXXXXXXX
//   REACT_APP_META_PIXEL_ID=e.g. 1444760610306290
// Events: PageView (auto at pixel init), Contact (standard, contact_method=whatsapp|telegram),
// plus custom events: whatsapp_click, telegram_click, pricing_cta_click, language_switch, page_view.
const GA4_ID = process.env.REACT_APP_GA4_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export const initAnalytics = () => {
  try {
    if (GA4_ID && !document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.async = true;
      s.id = "ga4-script";
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", GA4_ID);
    }
    if (PIXEL_ID && !document.getElementById("meta-pixel-script")) {
      if (!window.fbq) {
        // Meta-standard stub: closure reference (robust even if window.fbq is wrapped later).
        const fbqStub = function (...args) {
          fbqStub.callMethod
            ? fbqStub.callMethod.apply(fbqStub, args)
            : fbqStub.queue.push(args);
        };
        fbqStub.queue = [];
        fbqStub.loaded = true;
        fbqStub.version = "2.0";
        window.fbq = fbqStub;
      }
      const s = document.createElement("script");
      s.async = true;
      s.id = "meta-pixel-script";
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
      window.fbq("init", PIXEL_ID);
      window.fbq("track", "PageView");
    }
  } catch {}
};

export const trackEvent = (name, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === "function") window.gtag("event", name, params);
    if (typeof window.fbq === "function") window.fbq("trackCustom", name, params);
  } catch {}
};

// Meta STANDARD event — primary contact conversion for Ads / Events Manager.
export const trackContact = (method) => {
  try {
    if (typeof window.fbq === "function") {
      window.fbq("track", "Contact", { contact_method: method });
    }
  } catch {}
};
